export default "__VITE_ASSET__DMZ4GN6g__"